import React from 'react';
import { Glyphicon, ModalTrigger } from 'reaxl';
import renderVideoModal from './renderVideoModal';

const getCustomImageButton = (src, isEnhancedHero, ctaOptions) => (
    <input
        aria-label="play video"
        className="play-video-button"
        tabIndex="0"
        type="image"
        src={src}
        onClick={() => {
            if (isEnhancedHero) {
                ctaOptions.ctaOnMediaEvent({
                    type: 'impression',
                    eventLabel: 'start',
                });
            }
        }}
    />
);

const getPlayCircleButton = () => (
    <button
        type="button"
        aria-label="play video"
        className="play-video-button"
        tabIndex="0"
    >
        <Glyphicon
            className="play-video-button-icon"
            glyph="play-circle"
        />
    </button>
);

const renderPlayButton = ({
    video,
    ctaOptions,
    playButtonStyle,
    autoStart,
    originPage,
    withCustomImageButtonSrc,
    isEnhancedHero = false,
    className = '',
}) => (video.id && video.src ? (
    <div
        className={`col-xs-12 text-center play-video-icon ${className}`}
        data-cmp="play-video-icon"
        style={playButtonStyle}
    >
        <ModalTrigger modal={renderVideoModal(video, ctaOptions, autoStart, originPage)}>
            <span>
                {withCustomImageButtonSrc ? getCustomImageButton(withCustomImageButtonSrc, isEnhancedHero, ctaOptions) : getPlayCircleButton()}
            </span>
        </ModalTrigger>
    </div>
) : null);

export default renderPlayButton;
